module.exports = __webpack_public_path__ + "img/conquiz.adc85016.webp";